import React from "react";

export default function RegistroOk() {
  const nombre = localStorage.getItem("nombreEstudiante") || "Estudiante";

  return (
    <main className="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white px-6">
      <div className="text-center max-w-md">
        {/* Icono de éxito */}
        <div className="mb-6 text-6xl">
          <span className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-green-500/20 border-2 border-green-500">
            ✓
          </span>
        </div>

        {/* Título */}
        <h1 className="text-4xl font-bold mb-4">
          ¡Registro Exitoso!
        </h1>

        {/* Mensaje */}
        <p className="text-xl text-gray-300 mb-2">
          Bienvenido, <span className="font-semibold text-blue-400">{nombre}</span>
        </p>
        <p className="text-gray-400 mb-8">
          Tu registro ha sido guardado exitosamente. Haz click en el botón abajo para acceder al curso.
        </p>

        {/* Botón para continuar */}
        <div className="mt-8">
          <a
            href="/dashboard"
            className="inline-block px-8 py-3 bg-gradient-to-r from-blue-500 to-blue-600 text-white font-semibold rounded-lg shadow-lg hover:scale-105 transition-all"
          >
            Acceder al Curso
          </a>
        </div>
      </div>
    </main>
  );
}
